import request from "@/util/http";
// 	是否支付成功
export function is_pay_success(query) {
	return request({
		url: '/order/shop/payment/is_pay_success',
		method: 'get',
		params: query,
	})
}

/**
 * 首页
 */
export function index(data,params) {
	return request({
		url: '/order/shop/payment',
		method: 'post',
		data:data,
		params: params,
	})
}



/**
 * 支付前处理
 */
export function prePay(params) {
	return request({
		url: '/order/shop/payment/pre_pay',
		method: 'get',
		params: params,
	})
}

/**
 * 支付处理
 */
export function pay(params) {
	return request({
		url: '/order/shop/payment/pay',
		method: 'get',
		params: params,
	})
}



/**
 * 支付后处理
 */
export function postPay(params,paymentLogSn) {
	return request({
		url: '/order/shop/payment/post_pay_'+paymentLogSn,
		method: 'get',
		params: params,
	})
}

//支付前 生成支付记录
export function load(data,params) {
	return request({
		url: '/order/shop/payment/load',
		method: 'post',
		data:data,
		params: params,
	})
}

export function testPostPay(params,paymentLogSn) {
	return request({
		url: '/order/shop/payment/test_post_pay_'+paymentLogSn,
		method: 'get',
		params: params,
	})
}


// module.exports = {
// 	is_pay_success,
// 	index,
// 	prePay,
// 	pay,
// 	postPay,
// 	load,
// 	testPostPay
// }
